<template>
  <div>
    <v-card class='mx-2' outlined>
      <v-card-title>
        Systems
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          clearable
          @change="searchChange"
        ></v-text-field>
      </v-card-title>
      <v-data-table v-model="selected" 
        :headers="headers" 
        :items="systems" 
        :search="search" 
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @update:sort-by="saveSort"
        @update:sort-desc="saveSort"
        :items-per-page='parseInt("-1")'
        no-data-text="No Documents">
        <template v-slot:top>
          <v-dialog v-if="dialogSecrets === true" v-model="dialogSecrets"  max-width="60%" :key="dialogSecretsKey">
            <v-card>
              <v-card-title>
                <span class="headline">{{secretsTitle}}</span>
              </v-card-title>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="primary darken-1" @click="closeSecrets">OK</v-btn>
              </v-card-actions>
              <v-card-text> 
                <div>
                  <pre>{{secretsText}}</pre>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-if="dialog === true" v-model="dialog" max-width="60%" :key="dialogKey">
            <v-card>
              <v-card-title>
                <span class="headline">Edit System ({{ hostbase }})</span>
              </v-card-title>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="systemSerNum" label="Serial Number" placeholder="Serial Number, e.g. QF5119ED0013">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="systemModel" label="Model" placeholder="Model, e.g. QXS300-08">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="systemRev" label="Rev" placeholder="Rev, e.g. A2">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-select v-model="systemState" label="State" :items="states">
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-select v-model="systemOrderType" label="Order Type" :items="orderTypes">
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="systemPriority" label="Priority" placeholder="1-100"
                      v-validate="'required|min_value:1|max_value:100'" data-vv-name="systemPriority"
                      :error-messages="errors.collect('systemPriority')">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="systemSalesOrder" label="Sales Order" placeholder="Sales Order Number">
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-btn
                      color="primary"
                      :disabled="disableQadminPwdInvalidate"
                      @click="invalidateQadminPwd(systemSerNum)"
                    >
                      <v-icon small>fa-key</v-icon>
                    </v-btn>
                    Invalidate qadmin password
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-btn
                      color="primary"
                      :disabled="!showQxAppDelete"
                      @click="deleteQxAppPwd(systemSerNum)"
                    >
                      <v-icon small>fa-key</v-icon>
                    </v-btn>
                    Delete QxApp password
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn :disabled="errors.any()" color="primary darken-1" @click="save">Save</v-btn>
                <v-btn color="primary darken-1" @click="close">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-if="dialogPrint === true" v-model="dialogPrint" max-width="60%" :key="dialogPrintKey">
            <v-card>
              <v-card-title>
                <span class="headline">Print Labels</span>
              </v-card-title>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="systemSerNum" label="Serial Number" placeholder="Serial Number, e.g. QF5119ED0013">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="systemModel" label="Model" placeholder="Model, e.g. QXS300-08">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="systemRev" label="Rev" placeholder="Rev, e.g. A2">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="systemLabels" label="System Info/On-Prem Labels">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="boxLabels" label="Box Labels">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="username" label="qxControl Username/Integrator User" placeholder="Username">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="qxpwd" label="qadmin Password" placeholder="abcdefg" :key="qxpwd">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="qxcid" label="Qx Control ID (For On-Prem)" placeholder="qx7500f0" :key="qxcid">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="qxruser" label="Qx Root User (For On-Prem)" placeholder="qf2202p100e9" :key="qxruser">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="qxrpwd" label="Qx Root Password (For On-Prem)" placeholder="abcdefg" :key="qxrpwd">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn :disabled="errors.any()" color="primary darken-1" @click="printLabels">Print</v-btn>
                <v-btn color="primary darken-1" @click="closePrint">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon class='mr-2' @click="edit(item)"> edit  </v-icon>
          <v-icon class='mr-2' @click="systemDetails(item)"> list  </v-icon>
          <v-icon v-if="showAssignGateway === true" small class='mr-2' @click="assignGateway(item)"> fa-hdd  </v-icon>
          <v-icon small class='mr-2' @click="secrets(item)"> fa-key  </v-icon>
          <v-icon v-if="showDeleteGateway === true" class='mr-2' @click="deleteItem(item)"> delete  </v-icon>
          <v-icon v-if="showLabelPrint === true" small class='mr-2' @click="labels(item)"> fa-print  </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>


import env from '../../server.config'

/*  Example API return element
   "1": {
    "id": "06332419-9f76-11ea-9784-06853f280874",
    "model": "QXS500-32",
    "rev": "A2",
    "serNum": "QF2220ED0032",
    "wireguard": "10.237.0.1"
    "state": "ORDERED",
    "priority": "-1",
    "salesOrder": "test3",
    "components": null,
    "createdBy": "drittman",
    "createdDate": "2020-05-26 17:26:24",
    "modifiedBy": "drittman@qumulex.com",
    "modifiedDate": "2020-06-29 16:40:27"
  },
   */

const BAD_PASSWORD = "xxx";

export default {
  name: "Systems",
  props: {
    app: Object,
    searchSerNum: String   // serial number passed via route on which to search
  },
  data: () => ({
    sortBy: "createdDate",
    sortDesc: false,
    search: '',
    headers: [
      {
        text: 'Serial Number',
        align: 'center',
        value: 'serNum'
      },
      {
        text: 'WG Address',
        align: 'center',
        value: 'wireguard'
      },
      {
        text: 'Model',
        align: 'left',
        value: 'model'
      },
      {
        text: 'Rev',
        align: 'left',
        value: 'rev'
      },
      {
        text: 'Sales Order',
        align: 'left',
        value: 'salesOrder'
      },
      {
        text: 'Customer Id',
        align: 'left',
        value: 'customerId'
      },
      {
        text: 'Dist Id',
        align: 'left',
        value: 'distId'
      },
      {
        text: 'Order Type',
        align: 'left',
        value: 'orderType'
      },
      // These fields are not used by Ops presently
      // {
      //   text: 'State',
      //   align: 'left',
      //   value: 'state'
      // },
      // {
      //   text: 'Priority',
      //   align: 'left',
      //   value: 'priority'
      // },
      {
        text: 'Date Created',
        align: 'left',
        value: 'createdDate'
      },
      {
        text: 'Date Modified',
        align: 'left',
        value: 'modifiedDate'
      },
      {
        text: 'Actions',
        align: 'center',
        value: 'action',
        sortable: false
      }
    ],
    systems: [],
    selected: [],
    systemId: '',
    systemSerNum: '',
    hostbase: '',
    systemModel: '',
    systemRev: '',
    systemState: '',
    systemOrderType: '',
    systemPriority: 1,
    systemSalesOrder: '',
    secretsTitle: '',
    secretsText: '',
    dialog: false,
    dialogKey: 0,
    dialogPrint: false,
    dialogPrintKey: 0,
    dialogSecrets: false,
    dialogSecretsKey: 1,
    states: ["ORDERED", "QUEUED", "BUILDING", "TESTING", "SHIPPED", "RMA_PENDING", "RMA_RECEIVED", "QXA"],
    orderTypes: ["COMMERCIAL", "DEMO", "EAP", "INTERNAL", "ON_PREM_COMMMERCIAL", "ON_PREM_INTERNAL", "OUT_OF_SERVICE", "TBD"],
    showAssignGateway: false,
    showDeleteGateway: false,
    showLabelPrint: false,
    username: '',
    qxpwd: '',
    qxcid: '',
    qxruser: '',
    qxrpwd: '',
    gatewayIdAuthCode: '',
    disableQadminPwdInvalidate: false,
    showQxAppDelete: false
  }),

  created() {
    console.log('systems created')
    //this.initialize();
  },

  mounted() {
    console.log('systems mounted');
    if (this.searchSerNum?.length) {
      this.search = this.searchSerNum;
    } else if (sessionStorage.getItem('systemsSearchString')) {
      this.search = sessionStorage.getItem('systemsSearchString');
    } else {
      this.search = '';
    }
    let item = sessionStorage.getItem("systemsSortBy"); 
    if (item) this.sortBy = item;
    item = sessionStorage.getItem("systemsSortDesc"); 
    if (item) this.sortDesc = item === 'true';
    setTimeout(() => {
      this.initialize();
    }, 1000);
  },

  computed: {

  },

  methods: {
    initialize() {
      if(this.app?.userProfile?.role?.privileges && this.app?.userProfile?.role?.privileges.includes("qxcCrud")) {
        this.showAssignGateway = true;
        this.showDeleteGateway = true;
        this.showLabelPrint = true;
      } else {
        this.showAssignGateway = false;
        this.showDeleteGateway = false;
        this.showLabelPrint = false;
      }
      this.getSystems();
    },

    systemDetails(item) {
      //console.log('systemDetails' + JSON.stringify(item));
      this.$router.push('/SysDetails/' + item.serNum);
    },

    saveSort() {
      sessionStorage.setItem("systemsSortBy", this.sortBy); 
      sessionStorage.setItem("systemsSortDesc", this.sortDesc); 
    },

    searchChange() {
      if (this.search) {
        sessionStorage.setItem('systemsSearchString', this.search);
      } else {
        sessionStorage.setItem('systemsSearchString', "");
      }
    },

    async invalidateQadminPwd(sernum) {
      let msg = 'Are you sure you want to set the qadmin password for ' + sernum + ' to "Unknown"?\r\n'
      if (confirm(msg)) {
        const ret = await this.postPassword(sernum, {qxpwd: "Unknown"});
        if (ret) {
          this.dialog = false;
        }
      }
    },

    async deleteQxAppPwd(sernum) {
      let msg = 'Are you sure you want to delete the QxApp password for ' + sernum + '?\r\n'
      if (confirm(msg)) {
        const ret = await this.postPassword(sernum, {qxrpwd: "Removed"});
        if (ret) {
          this.dialog = false;
        }
      }
    },
    
    async edit(item) {
      this.systemId = item.id
      this.systemSerNum = item.serNum
      this.hostbase = item.wireguard.split(' ')[1].toUpperCase()
      this.systemModel = item.model
      this.systemRev = item.rev
      this.systemState = item.state
      this.systemOrderType = item.orderType
      this.systemPriority = item.priority
      this.systemSalesOrder = item.salesOrder
      const pwd = await this.getQadminPassword(item.id)
      if (pwd.qxpwd == "Unknown" || pwd.qxpwd == "" || pwd.qxpwd == BAD_PASSWORD) {
        this.disableQadminPwdInvalidate = true;
      } else {
        this.disableQadminPwdInvalidate = false;
      }
      if (pwd.qxrpwd == "Removed" || pwd.qxrpwd == "" || pwd.qxrpwd == BAD_PASSWORD) {
        this.showQxAppDelete = false;
      } else {
        this.showQxAppDelete = true;
      }
      this.dialog = true;
    },

    assignGateway(item) {
      //console.log('assignGateway' + JSON.stringify(item));
      this.$router.push('/gateway/' + item.serNum);
    },

    secrets(item) {
      this.secretsTitle = item.serNum + " Secrets"
      this.getSecrets(item.id)
      this.systemId = item.id
      this.systemSerNum = item.serNum
      this.systemModel = item.model
      this.systemRev = item.rev
      this.systemState = item.state
      this.systemOrderType = item.orderType
      this.systemPriority = item.priority
      this.systemSalesOrder = item.salesOrder
      this.dialogSecrets = true;
    },

    async labels(item) {
      this.gatewayIdAuthCode = '';
      this.canRegister(item.serNum)
      const pwd = await this.getQadminPassword(item.id);
      if (pwd.qxpwd == "Unknown" || pwd.qxpwd == "" || pwd.qxpwd == BAD_PASSWORD) {
        alert("No qadmin password for " + item.serNum);
      }
      this.qxpwd = pwd.qxpwd;
      if (pwd.qxrpwd == BAD_PASSWORD) {
        this.qxrpwd = "";
      } else {
        this.qxrpwd = pwd.qxrpwd;
      }
      this.systemId = item.id
      this.systemSerNum = item.serNum
      this.systemModel = item.model
      this.systemRev = item.rev
      this.systemLabels = 4
      this.qxruser = String(item.serNum).toLowerCase()
      this.qxcid = item.wireguard.split(" ")[1]
      this.username = item.username
      this.boxLabels = 4
      this.dialogPrint = true;
    },

    deleteItem(item){
      if (confirm("Are you sure you want to delete " + item.serNum + "?")) {
        this.deleteSystem(item.id)
      }
    },

    save() {
      this.updateSystem(this.systemId)
      this.dialog = false
    },

    close() {
      this.dialog = false
    },
    closePrint() {
      this.dialogPrint = false
    },

    closeSecrets() {
      this.secretsText = ''
      this.secretsTitle = ''
      this.dialogSecrets = false
    },

    getSystems() {
      this.app.restApi({
          method: 'get',
          url: '/API/public/systems',
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          this.systems = Object.values(response.data);
          for (let system of this.systems) {
            const octets = system.wireguard.split('.')
            let hostbase = " qx" + parseInt(octets[1]).toString(16).padStart(2,'0');
            hostbase += parseInt(octets[2]).toString(16).padStart(2,'0');
            hostbase += parseInt(octets[3]).toString(16).padStart(2,'0');
            system.wireguard += hostbase;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

  printLabels() {
      let url = "/public/labels/printLabels.php"
      url += "?serNum=" + this.systemSerNum
      url += "&model=" + this.systemModel
      url += "&rev=" + this.systemRev
      url += "&qxpass=" + this.qxpwd
      url += "&username=" + this.username
      url += "&blqty=" + this.boxLabels
      url += "&slqty=" + this.systemLabels
      url += "&qxcid=" + this.qxcid
      url += "&qxruser=" + this.qxruser
      url += "&qxrpwd=" + encodeURIComponent(String(this.qxrpwd))
      url += "&print=true"
      url += this.gatewayIdAuthCode ? `&authcode=${this.gatewayIdAuthCode}` : ''
      console.log('printLabels(): url=' + url)
      this.app.restApi({
          method: 'post',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.log(response);
          this.getSystems() // refresh table
        })
        .catch(error => {
          console.log(error);
          alert("Update System failed (" + error.response.status + ")")
        });
    },

  getSecrets(id) {
      let url = '/API/public/system/' + id + '/secrets'
      url += "?prodLevel=" + env.prodLevel
      this.app.restApi({
          method: 'get',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          //console.log(response.data);
          this.secretsText = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

  async postPassword(sernum, password) {
    let url = '/API/public/system/' + sernum + '/secrets'
    let ret = false;
    await this.app.restApi({
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + this.app.userProfile.token
        },
        data: {
          prodLevel: env.prodLevel,
          ...("qxpwd"  in password) && {qadminPwd: password.qxpwd},
          ...("qxrpwd" in password) && {qxAppOpsPwd: password.qxrpwd}
        }
      })
      // eslint-disable-next-line no-unused-vars
      .then(response => {
        //console.log(response)
        let msg = `Successfully saved qadmin password ${password} to ${sernum}/secrets.`
        alert(msg)
        ret = true;
      })
      .catch( error => {
        if (error.response.status === 404) {
          alert("System with serial number " + sernum + " not found.")
        } else {
          let msg = "Unable to save qadmin password for " + sernum;
          msg += ". (" + error.response.status + ")"
          alert(msg)
        }
        ret = false;
      });
      return ret;
    },

  async getQadminPassword(id) {
      let url = '/API/public/system/' + id + '/secrets'
      let qxpwd = BAD_PASSWORD;
      let qxrpwd = BAD_PASSWORD;
      url += "?prodLevel=" + env.prodLevel
      await this.app.restApi({
          method: 'get',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          for (let i = 0; i < response.data.split("\n").length; i++) {
            if (response.data.split("\n")[i] == "qadmin_pwd:") {
              qxpwd = response.data.split("\n")[i+1];
            }
            else if (response.data.split("\n")[i] == "qx_app_ops_pwd:") {
              qxrpwd = response.data.split("\n")[i+1];
            }
          }
        })
        .catch( error => {
          alert("Error getting password for " + id + ": " + error?.response?.status);
        });
      if (qxpwd == BAD_PASSWORD) {
        alert("No qadmin password for " + id);
      }
      return {qxpwd: qxpwd, qxrpwd: qxrpwd};
    },

  // For label printing, is this a distribution system?
  canRegister(id) {
      let url = '/API/public/system/canregister/' + id;
      this.app.restApi({
          method: 'get',
          url: url,
        })
        .then(response => {
          console.debug("systems::canRegister() response", response);  
          this.getGatewayId(id);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

  getGatewayId(id) {
    let url = '/API/public/system/' + id + '/gw'
      this.app.restApi({
          method: 'get',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.debug("systems::getGatewayId() ", response.data);
          this.gatewayIdAuthCode = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
  },

    updateSystem(id) {
      let url = '/API/public/system/' + id
      url += "?serNum=" + this.systemSerNum
      url += "&model=" + this.systemModel
      url += "&rev=" + this.systemRev
      url += "&state=" + this.systemState
      url += "&orderType=" + this.systemOrderType
      url += "&priority=" + this.systemPriority
      url += "&salesOrder=" + this.systemSalesOrder
      console.log('updateSystem(): url=' + url)
      this.app.restApi({
          method: 'post',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.log(response);
          this.getSystems() // refresh table
        })
        .catch(error => {
          console.log(error);
          alert("Update System failed (" + error.response.status + ")")
        });
    },

    deleteSystem(id) {
      this.app.restApi({
          method: 'delete',
          url: '/API/public/system/' + id,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.log(response);
          this.getSystems() // refresh table
        })
        .catch(function (error) {
          console.log(error);
          alert("Delete System failed (" + error.response.status + ")")
        });
    },

  }
}
</script>
